module.exports = __webpack_public_path__ + "static/1_1_defineai_BG-59e16e6822542100b58c8658068727e6.svg";